<template>
  <!-- Pozadí -->
  <v-app :style="{ background: AppBackGround }" class="fill-height">
    <!-- Hlavička -->
    <v-app-bar app dense color="green darken-4" class="">
      <span class="d-none d-sm-flex">{{ AppTitle2 }}</span>
      <v-spacer />
      <v-app-bar-title class="accent2--text">{{ AppTitle1 }}</v-app-bar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="AppBackGroundImage_view = !AppBackGroundImage_view" class="mr-1">
            <v-icon v-if="AppBackGroundImage_view">mdi-border-none-variant</v-icon>
            <v-icon v-else>mdi-forest </v-icon>
          </v-btn>
        </template>
        <span>Podkladový obrázek</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on"
            href="https://mze.gov.cz/ssl/logout.html?goto=http://mze.gov.cz/public/web/" v-if="AppCategory == 'LHPO'"
            class="">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>Portál eAGRI - odhlášení</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab color="white" class="mt-3 d-none d-sm-flex" v-bind="attrs" v-on="on" href="https://nli.gov.cz/"
            target="_blank">
            <img height="36" :src="AppAssetsUrl + '/img/logo/logo_Nli_11.png'" />
          </v-btn>
        </template>
        <span>Národní lesnický institut</span>
      </v-tooltip>
    </v-app-bar>

    <!-- Navigace - levý pruh-->
    <v-navigation-drawer app expand-on-hover permanent v-if="NavigationVisibility">
      <v-list dense>
        <!-- První seznam - SlotBack--->
        <v-list-item-group v-model="VybCompBack" color="green lighten-3" v-if="!CompListBack == []">
          <v-list-item v-for="item in CompListBack" :key="item.name" :value="item.name">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

        <!-- Druhý seznam - SlotFront-->
        <v-list-item-group v-model="VybCompFront" color="green lighten-3" v-if="!CompListFront == []">
          <template v-for="item in CompListFront">
            <v-list-item v-if="!item.navigationinvisible" :key="item.name" :value="item.name">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

        </v-list-item-group>

        <v-divider />

        <!-- Třetí seznam - SlotTop--->
        <v-list-item-group v-model="VybCompTop" color="green accent-3" v-if="!CompListTop == []">
          <v-list-item v-for="item in CompListTop" :key="item.name" :value="item.name">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <!-- Komponenty -->
    <v-main>
      <!-- Komponenta pro zobrazení a přepínání ze seznamu CompListBack -->
      <template v-if="typeof CompListBack !== 'undefined' &&
        CompListBack != null &&
        CompListBack.length != null &&
        CompListBack.length > 0
      ">
        <keep-alive>
          <!-- id="ContBack" -->
          <component :is="VybCompBackType" :key="VybCompBack" :CompName="VybCompBack" :AssetsUrl="AppAssetsUrl"
            :AppCategory="AppCategory" :AppURLParams="AppURLParams" :AppUseWebGL="AppUseWebGL"
            :AppServiceurl="AppServiceurl" :CompList="CompList">
          </component>
        </keep-alive>
      </template>

      <!-- Komponenta pro zobrazení a přepínání ze seznamu CompListFront -->
      <template v-if="typeof CompListFront !== 'undefined' &&
        CompListFront != null &&
        CompListFront.length != null &&
        CompListFront.length > 0
      ">
        <keep-alive>
          <!-- uvnitř keep-alive si při přepínání zachovávají prvky svoje vlastnosti -->
          <!-- id="ContFront" -->
          <component :is="VybCompFrontType" :key="VybCompFront" :CompName="VybCompFront" :AssetsUrl="AppAssetsUrl"
            :AppCategory="AppCategory" :AppURLParams="AppURLParams" :AppUseWebGL="AppUseWebGL"
            :AppServiceurl="AppServiceurl" :CompList="CompList">
          </component>
        </keep-alive>
      </template>

      <!-- Komponenta pro zobrazení a přepínání ze seznamu CompListTop -->
      <template v-if="typeof CompListTop !== 'undefined' &&
        CompListTop != null &&
        CompListTop.length != null &&
        CompListTop.length > 0
      ">
        <keep-alive>
          <!-- id="ContTop" -->
          <component :is="VybCompTopType" :key="VybCompTop" :CompName="VybCompTop" :AssetsUrl="AppAssetsUrl"
            :AppCategory="AppCategory" :AppURLParams="AppURLParams" :AppUseWebGL="AppUseWebGL"
            :AppServiceurl="AppServiceurl" :CompList="CompList">
          </component>
        </keep-alive>
      </template>
    </v-main>

    <!-- Zápatí -->
    <v-footer app height="42" class="d-none d-sm-flex" v-if="!AppFooter == ''">
      <!-- Komponenta pro zobrazobání zápatí -->
      <component :is="AppFooter" :AssetsUrl="AppAssetsUrl" :AppCategory="AppCategory" :AppURLParams="AppURLParams"
        :AppServiceurl="AppServiceurl" :CompList="CompList"></component>

      <!-- <vzornik class="d-none" /> -->
    </v-footer>

    <!-- Úvodní informace /> -->
    <v-dialog v-model="AppBasicInfo_view" max-width="700">
      <v-alert type="warning">

        <!-- LHPO  -->
        <div>
          Vážení uživatelé mapových aplikací NLI, v současné době probíhají zásadní úpravy databázové struktury
          Datového
          skladu Informačního a datového centra NLI (dále jen DS IDC).
        </div>
        <div>
          Důsledkem úprav je dočasná nedostupnost dat LHP a LHO přijatých do DS IDC v roce 2023.
        </div>
        <div>
          Obnovení dostupnosti těchto dat předpokládáme od 1. července t. r.
        </div>
        <div>
          Omlouváme se za komplikace a děkujeme Vám za pochopení.
        </div>
      </v-alert>

    </v-dialog>




  </v-app>
</template>

<script>
// import AppBack from "./components/pokusy/AppBack.vue";
// import Vzornik from "./components/pokusy/vzornik.vue";
import AppConfig from "./assets/AppConfig.json";

import { getGPUTier } from "detect-gpu";

export default {
  name: "App",

  components: {
    // AppBack,
    // Vzornik,

    // Asynchronní načtení - až když se použije
    BasicMenu: () => import("./components/BasicMenu.vue"),
    LhcVyber: () => import("./components/LhcVyber.vue"),
    LhcInfo: () => import("./components/LhcInfo.vue"),
    LhcJprlKniha: () => import("./components/LhcJprlKniha.vue"),
    LhcKniha: () => import("./components/LhcKniha.vue"),
    Map: () => import("./components/Map.vue"),
    Kn: () => import("./components/Kn.vue"),
    //KnSt: () => import("./components/KnSt.vue"),
    //KnParNah: () => import("./components/KnParNah.vue"),
    CisIslh: () => import("./components/CisIslh.vue"),
    fiLhpo: () => import("./components/FooterInfo/fiLhpo.vue"),
    InfoBhist: () => import("./components/InfoBhist.vue"),
    InfoZdsl: () => import("./components/InfoZdsl.vue"),
    InfoPato: () => import("./components/InfoPato.vue"),
        InfoRyby: () => import("./components/InfoRyby.vue"),
  },

  data: () => ({
    // Jméno aplikace - vlastnost AppName v konfiguračním souboru
    // Určuje druh aplikace
    AppName: "",
    // Nadpis aplikace - uprostřed
    AppTitle1: "",
    // Nadpis aplikace - nalevo
    AppTitle2: "",
    // adresa na Assets
    AppAssetsUrl: null,
    // Kategorie aplikace
    AppCategory: "",
    // Parametry spuštění - z příkazové řádky
    AppURLParams: URLSearchParams,
    // Zápatí aplikace
    AppFooter: "",
    // Adresy na služby
    AppServiceurl: "",
    // Seznam komponent z konfiguračníhou souboru AppConfig.json
    CompList: [],
    // Zda je vidět obrázek na pozadí
    AppBackGroundImage_view: true,
    // Barva pozadí, když není vidět obrázek (grey lighten-2)
    AppBackGroundColor: "#E0E0E0",
    // Zda je vidět úvodní informace
    AppBasicInfo_view: false,
    // Zda lze použít WebGL
    AppUseWebGL: true,
    pokus: true,
  }),

  computed: {
    // Vybraná komponenta
    VybComp: {
      get() {
        return this.$store.getters.GET_sVybComp;
      },
      set(newValue) {
        this.$store.commit("SET_sVybComp", newValue);
      },
    },

    // Vybraná komponenta pro kontejner ContFront
    VybCompFront: {
      get() {
        return this.VybComp.SlotFront;
      },
      set(newValue) {
        this.VybComp = {
          CompName: newValue,
          SlotName: "SlotFront",
        };
      },
    },

    // Vybraná komponenta pro kontejner ContBack
    VybCompBack: {
      get() {
        return this.VybComp.SlotBack;
      },
      set(newValue) {
        this.VybComp = {
          CompName: newValue,
          SlotName: "SlotBack",
        };
      },
    },

    // Vybraná komponenta pro kontejner ContTop
    VybCompTop: {
      get() {
        return this.VybComp.SlotTop;
      },
      set(newValue) {
        this.VybComp = {
          CompName: newValue,
          SlotName: "SlotTop",
        };
      },
    },

    // Vybraná komponenta pro kontejner ContFront - typ
    VybCompFrontType: function () {
      if (!this.VybCompFront == null || !this.VybCompFront == "") {
        return this.CompList.find((item) => item.name == this.VybCompFront)
          .type;
      } else {
        return null;
      }
    },

    // Vybraná komponenta pro kontejner ContBack - typ
    VybCompBackType: function () {
      if (!this.VybCompBack == null || !this.VybCompBack == "") {
        return this.CompList.find((item) => item.name == this.VybCompBack).type;
      } else {
        return null;
      }
    },

    // Vybraná komponenta pro kontejner ContTop - typ
    VybCompTopType: function () {
      if (!this.VybCompTop == null || !this.VybCompTop == "") {
        return this.CompList.find((item) => item.name == this.VybCompTop).type;
      } else {
        return null;
      }
    },

    // Vybraná komponenta pro kontejner ContTop - zobrazení
    VybCompTopView: function () {
      if (
        typeof this.VybCompTop != "undefined" &&
        this.VybCompTop != null &&
        this.VybCompTop != ""
      ) {
        return true;
      } else {
        return false;
      }
    },

    // Seznam komponent pro kontejner ContFront
    CompListFront: function () {
      return this.CompList.filter(function (comp) {
        return comp.slot == "SlotFront";
      });
    },
    // Seznam komponent pro kontejner ContBack
    CompListBack: function () {
      return this.CompList.filter(function (comp) {
        return comp.slot == "SlotBack";
      });
    },
    // Seznam komponent pro kontejner ContTop
    CompListTop: function () {
      return this.CompList.filter(function (comp) {
        return comp.slot == "SlotTop";
      });
    },

    // Obrázek pozadí
    AppBackGround: function () {
      if (this.AppBackGroundImage_view) {
        return (
          // číslo 73 udává max počet obrázků v adresáři /assets/img/ - když se přidají další, změnit
          "url(" +
          this.AppAssetsUrl +
          "/img/background/" +
          (Math.floor(Math.random() * 73) + 1) +
          ".jpg" +
          ")"
        );
      } else {
        return this.AppBackGroundColor;
      }
    },

    // Zobrazení levé navigace
    NavigationVisibility: function () {
      // Navigace je zobrazena, když je prvků v CompList víc jak jedna
      if (this.CompList == []) {
        return false;
      } else if (this.CompList.length < 2) {
        return false;
      } else if (this.CompList.filter(function (item) {
        return !item.navigationinvisible;
      }).length < 2) {
        return false;
      } else {
        return true;
      }
    },
  },

  methods: {

    // Inicializace mapy - nová mapa
    GetGPU: async function () {
      const gpuTier = await getGPUTier();
      console.log("GPUTier: " + gpuTier.tier + ", GPUfps: " + gpuTier.fps);

      if (typeof gpuTier.tier == 'undefined' || gpuTier.tier > 1) {
        this.AppUseWebGL = true
      } else {
        this.AppUseWebGL = false
      }
    },
  },

  watch: {},

  // při otevření aplikace
  created() {

    console.log("App created");

    // Test na GPU
    this.GetGPU()

    // Parametry spuštění
    this.AppURLParams = new URLSearchParams(window.location.search);
    console.log(this.AppURLParams)

    // Druh aplikace
    // Za prvé se vezme z parametru AppName
    if (this.AppURLParams.has("AppName")) {
      this.AppName = this.AppURLParams.get("AppName")
    } else {
      // Za druhé se vezme z názvu aplikace (třetí položka v window.location.pathname)
      // Název musí existovat v AppConfig.json a musí být povolen (EnableFromPath)
      var vPathName = window.location.pathname.split("/")
      //vPathName = (new URL('https://www.ga.nli.gov.cz/DsNli/Dpz/index.html?filename=tryjsref_loc_origin1')).pathname.split("/")
      //console.log(vPathName)
      var sAppName = vPathName[2]
      //console.log(sAppName)
      if (sAppName !== ""
        && AppConfig[sAppName] !== undefined
        && AppConfig[sAppName].EnableFromPath) {
        this.AppName = sAppName
      } else {
        // Za třetí se vezme z konfiguračního souboru
        this.AppName = AppConfig.AppName;
      }
    }
    console.log(this.AppName)

    //Nastavení aplikace   
    document.title = AppConfig[this.AppName].AppIndexHtmlTitle;
    this.AppTitle1 = AppConfig[this.AppName].AppTitle1;
    this.AppTitle2 = AppConfig[this.AppName].AppTitle2;
    this.AppAssetsUrl = AppConfig[this.AppName].AppAssetsUrl;
    this.AppCategory = AppConfig[this.AppName].AppCategory;
    this.AppFooter = AppConfig[this.AppName].AppFooter;
    this.AppServiceurl = AppConfig[this.AppName].AppServiceurl;
    this.CompList = AppConfig[this.AppName].CompList;
    // Zobrazení výchozích komponet
    AppConfig[this.AppName].VybComp.split(",").forEach((value) => {
      this.VybComp = {
        CompName: value,
        SlotName: this.CompList.find((item) => item.name == value).slot,
      };
    });
  },
};
</script>

<style>
html {
  overflow-y: auto !important;
}

/* Základní formát pozadí - pro obrázek nebo barvu na pozadí */
.v-application {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}

/* Aby se nezalamovaly texty uprostřed slova, možná bude v další verzi vuetify odstraněno */
.v-card__text,
.v-card__title {
  word-break: normal !important;
}

/* Šířka podle rodiče pro obsah Snacbars */
.v-snack__content {
  width: 100%;
}

/* Posunutí slotu Extension pro Toolbar */
.v-toolbar__extension {
  padding-left: 0px !important;
  padding-right: 0px !important;
  max-width: max-content;
}

/* Minimální šířka pro výběry při focusu (výchozí 64px) */
.u_v-autocomplete.v-select.v-input--is-focused input {
  min-width: 0px !important;
}

/* Šířka 100% */
.fill-width {
  width: 100%;
}

/* Pozicování absolutní */
.u_posAbs {
  position: absolute !important;
}

/* Pozicování vpravo */
.u_posRigth {
  right: 0 !important;
}

/* Pozicování vlevo */
.u_posLeft {
  left: 0 !important;
}

/* Pozicování dole */
.u_posBottom {
  bottom: 0 !important;
}

/* Pozicování dole */
.u_posTopNone {
  top: auto !important;
}

/* Pozicování nahoře */
.u_posTop {
  top: 0 !important;
}
</style>
